import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-survey-script',
  templateUrl: './survey-script.component.html',
  styleUrls: ['./survey-script.component.scss']
})
export class SurveyScriptComponent implements OnInit, AfterViewInit {

  surveyWidgetUrl='';

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    //this.translate.stream('survey-widget-url').subscribe(surveyUrl => {
      const script = document.createElement('script');
      // tslint:disable-next-line: max-line-length
      script.src = 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdyrLe4Ns0eubJYLkQ_2Br4qlte2PTb_2BP_2F7v34Rp4NK_2FbhR.js';
      document.getElementById('smcx-sdk').appendChild(script);
    //})

  
    
  }

}
